import React from 'react';
import {useTranslation} from 'tolgee';

import {Alert} from './Alert';

export function NoContentAlert({text, title}: {text?: string; title?: string}): JSX.Element {
  const {t} = useTranslation('error');
  return (
    <Alert
      severity='info'
      title={title ? title : t('noData')}
      msgCreator={() => (text ? text : t('noDataForFilter'))}
    />
  );
}
